import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { GameMediaService } from '@core/services/game-media.service';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed, Game, MediaItem, UntilDestroy } from '@mtgame/core';
import { SeoService } from '@core/services/seo.service';
import { getGameMediaItemRoute } from '@config/routes';
import { GameRootService } from '@core/services/game-root.service';

@UntilDestroy
@Component({
  selector: 'mtg-tournament-game-media',
  templateUrl: './tournament-game-media.component.html',
  styleUrls: ['./tournament-game-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentGameMediaComponent implements OnInit, OnDestroy {
  game: Game;
  images: MediaItem[];
  videos: MediaItem[];

  constructor(
    private gameRootService: GameRootService,
    private gameMediaService: GameMediaService,
    private cdr: ChangeDetectorRef,
    private seoService: SeoService,
  ) {
  }

  ngOnInit(): void {
    combineLatest([
      this.gameRootService.game$.pipe(takeUntil(componentDestroyed(this))),
      this.gameMediaService.media$.pipe(takeUntil(componentDestroyed(this)))
    ]).subscribe(([game, media]) => {
      this.game = game;
      this.images = media.filter(item => item.originalPhoto.id);
      this.videos = media.filter(item => item.videoUrl);
      this.cdr.markForCheck();
    });

    this.gameRootService.game$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(game => {
        let title = '';
        let description = '';
        if (game.isClosed) {
          const winnerTeam = game.isTeamWon ? game.team : game.competitorTeam;
          const loserTeam = game.isTeamWon ? game.competitorTeam : game.team;
          if (game.team.sport.isHockey()) {
            description = `Победа ${winnerTeam.name} в игре против ${loserTeam.name}`;
          } else {
            description = `Победа ${winnerTeam.name} в матче против ${loserTeam.name}`;
          }
        }
        if (game.team.sport.isHockey()) {
          title = `Медиа. Игра ${game.team.name} против ${game.competitorTeam.name}`;
        } else {
          title = `Медиа. Матч ${game.team.name} против ${game.competitorTeam.name}`;
        }
        this.seoService.setData({
          title,
          description,
        });
      });
  }

  ngOnDestroy(): void {
    this.seoService.reset();
    // this.gameMediaService.dispose();
  }

  get mediaRoute(): string {
    return getGameMediaItemRoute(this.game.id).join('/');
  }
}
